import { render, staticRenderFns } from "./CardGroupEdit.vue?vue&type=template&id=573a6e7a&scoped=true&"
import script from "./CardGroupEdit.vue?vue&type=script&lang=js&"
export * from "./CardGroupEdit.vue?vue&type=script&lang=js&"
import style0 from "./CardGroupEdit.vue?vue&type=style&index=0&id=573a6e7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573a6e7a",
  null
  
)

export default component.exports